import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Undo2 } from 'lucide-react';
import EditableNumberCell from '../data_table/EditableNumberCell';
import IconButton from '../ui/IconButton';
import { cx } from '../ui/classNames';

// A bare warning-coloured icon at the cell's right edge, as the DataGrid's
// dirty-cell Undo icon looked.
const UNDO_BUTTON_CLASS_NAME = 'absolute right-0 top-1/2 -translate-y-1/2 !border-transparent !bg-transparent '
    + '!text-ui-warning hover:!bg-ui-hover';

/**
 * A Position Sizing input cell: an EditableNumberCell (its props pass
 * through) and, while `showUndo` (the value differs from the saved one), an
 * Undo button at the cell's right edge that calls `onUndo` without the
 * click reaching the row. The button hides while the cell is being edited.
 */
export default function EditableCellWithUndo({
    showUndo = false,
    onUndo,
    undoLabel,
    onEditingChange,
    className,
    ...cellProps
}) {
    const [editing, setEditing] = useState(false);
    const undoVisible = showUndo && !editing;
    return (
        <div className="relative">
            <EditableNumberCell
                {...cellProps}
                className={cx(undoVisible && 'pr-6', className)}
                onEditingChange={(nextEditing) => {
                    setEditing(nextEditing);
                    onEditingChange?.(nextEditing);
                }}
            />
            {undoVisible && (
                <IconButton
                    size="xs"
                    label={undoLabel}
                    className={UNDO_BUTTON_CLASS_NAME}
                    onClick={(event) => {
                        event.stopPropagation();
                        onUndo();
                    }}
                >
                    <Undo2 size={16} strokeWidth={2.25} aria-hidden="true" />
                </IconButton>
            )}
        </div>
    );
}

EditableCellWithUndo.propTypes = {
    showUndo: PropTypes.bool,
    onUndo: PropTypes.func.isRequired,
    undoLabel: PropTypes.string.isRequired,
    onEditingChange: PropTypes.func,
    className: PropTypes.string,
};
